import React from 'react';
import { Box } from '@mui/material';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CheckIcon from '@material-ui/icons/Check';

/**
 * The tinted note that sits under a form in the PW deck — slides 35-38 (create),
 * 39-41 (edit) and 42 (add a school to a network).
 *
 * The mock draws these as a soft filled panel with NO border: a pale blue-grey
 * fill and a muted ⓘ for information, and a pale green fill with a green ✓ for
 * the one that confirms what happens on publish. Every notice across the three
 * dialogs is the same object, so it lives here rather than being restyled by
 * hand in each of them — which is how they drifted apart in the first place.
 *
 * @param {'info'|'success'} [variant]
 */
const VARIANTS = {
    info: {
        bg: 'var(--brand-notice-bg, #F1F5F9)',
        fg: 'var(--brand-notice-text, #5A6472)',
        icon: 'var(--brand-notice-icon, #94A3B8)',
        Icon: InfoOutlinedIcon,
    },
    success: {
        bg: 'rgba(16, 185, 129, 0.08)',
        fg: '#3F5A4E',
        icon: '#2E7D32',
        Icon: CheckIcon,
    },
};

const FormNotice = ({ variant = 'info', children, sx = {} }) => {
    const v = VARIANTS[variant] || VARIANTS.info;
    const Icon = v.Icon;

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.25,
            backgroundColor: v.bg,
            color: v.fg,
            borderRadius: '10px',
            padding: '12px 14px',
            fontSize: 13,
            lineHeight: 1.5,
            ...sx,
        }}>
            <Icon style={{ fontSize: 16, flexShrink: 0, marginTop: 2, color: v.icon }} />
            <Box component="span" sx={{ minWidth: 0 }}>{children}</Box>
        </Box>
    );
};

export default FormNotice;
